import HttpApi, { response } from './HttpApi';
import { OneResponse } from '../types/api/user';

// LEGACY CODE
export class UserApi extends HttpApi {
  async me() {
    const { result } = await this.get<OneResponse>('/me');
    return result;
  }

  // The same me request, but without authorization checking
  async guestMe() {
    const { result } = await response<OneResponse>(this.http.get('/me'));
    return result;
  }

  logout() {
    return this.http.get('/oauth/logout');
  }
}

export default new UserApi('/users');
